import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface AdminOrg {
  id: string;
  name: string;
  org_type: string;
  property_count: number;
  created_at: string | null;
}

export function useAdminOrgs(enabled: boolean) {
  return useQuery<AdminOrg[]>({
    queryKey: ['admin-orgs'],
    queryFn: async () => {
      const { data, error } = await supabase.rpc('admin_list_orgs');
      if (error) throw error;
      return (data ?? []) as AdminOrg[];
    },
    enabled,
    staleTime: 60_000,
  });
}
